import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { InvoiceListPeriodEndCell } from './invoice-list-period-end.cell';
import { InvoiceListPeriodEndHeader } from './invoice-list-period-end.header';

export const InvoiceListPeriodEndColumn: IdentifiedColumnDef<
  InvoiceModel,
  InvoiceModel['periodEnd']
> = {
  enableSorting: true,
  header: InvoiceListPeriodEndHeader,
  cell: InvoiceListPeriodEndCell,
  meta: { maxWidth: '165px', width: '160px' },
};
